module.exports = __webpack_public_path__ + "img/uparrow.e5410b75.svg";